import React, {Fragment, useState} from 'react'
import {translate} from 'react-i18next'
import {DisplayFormButton, DropdownIcon, DisplayFormContainer} from './LogisterFormDropdownStyles'

const useFormDisplayState = () => {
  const [shouldBeDisplayed, setDisplayState] = useState(false)
  const toggleDisplayState = () => setDisplayState(!shouldBeDisplayed)

  return [shouldBeDisplayed, toggleDisplayState]
}

const LogisterFormDropdown = ({t, children, withPlatformAuthentication}) => {
  const [shouldBeDisplayed, toggleDisplayState] = useFormDisplayState()

  if (!withPlatformAuthentication) {
    return children
  }

  return (
    <Fragment>
      <DisplayFormContainer shouldBeDisplayed={shouldBeDisplayed}>
        <DropdownIcon onClick={toggleDisplayState} isFocused={shouldBeDisplayed} />
        <DisplayFormButton onClick={toggleDisplayState}>
          {shouldBeDisplayed ? t('webauthn-dropdown.button.open') : t('webauthn-dropdown.button.closed')}
        </DisplayFormButton>
      </DisplayFormContainer>
      {shouldBeDisplayed && children}
    </Fragment>
  )
}

export default translate()(LogisterFormDropdown)
